import { Card } from "@cmsgov/ds-medicare-gov";
import React, { FunctionComponent } from "react";
import { PrescriptionDrug } from "../../../@types";
import {
  CONSTANTS,
  displayDrug,
  displayPackage,
  useTranslate,
} from "../../../helpers";

interface DrugCardProps {
  drug: PrescriptionDrug;
}

const DrugCard: FunctionComponent<DrugCardProps> = ({ drug }) => {
  const t = useTranslate();
  const packageType = displayPackage(t, drug);
  return (
    <Card className="mct-c-summary-page-drug-card">
      <div
        className="mct-c-summary-page-drug-card-header"
        data-testid="drug-card"
      >
        <h3 className="mct-c-summary-page-drug-card-header__drug-name">
          {displayDrug(t, drug)}{" "}
        </h3>
        {drug.is_generic && (
          <span className="mct-c-summary-page-drug-card-header__is-generic">
            {t("prescription.generic")}
          </span>
        )}
      </div>
      <div className="mct-c-summary-page-drug-card-features">
        {drug.use_package_quantity ? (
          <div className="mct-c-summary-page-drug-card-features__column mct-c-summary-page-drug-card-features__column--package-type">
            <>
              <h4 className="mct-c-summary-page-drug-card-features__headings">
                {t("prescription.package_type")}
              </h4>
              <p className="mct-c-summary-page-drug-card-features__values">
                {packageType}
              </p>
            </>
          </div>
        ) : (
          <div className="mct-c-summary-page-drug-card-features__column mct-c-summary-page-drug-card-features__column--placeholder" />
        )}
        <div className="mct-c-summary-page-drug-card-features__column mct-c-summary-page-drug-card-features__column--quantity">
          <h4 className="mct-c-summary-page-drug-card-features__headings">
            {t("prescription.quantity")}
          </h4>
          <p className="mct-c-summary-page-drug-card-features__values">
            {drug.quantity}
          </p>
        </div>
        <div className="mct-c-summary-page-drug-card-features__column mct-c-summary-page-drug-card-features__column--frequency">
          <h4 className="mct-c-summary-page-drug-card-features__headings">
            {t("prescription.frequency")}
          </h4>
          <p className="mct-c-summary-page-drug-card-features__values">
            {t(CONSTANTS.prescriptionFrequencyLabels[drug.frequency])}
          </p>
        </div>
      </div>
    </Card>
  );
};

export default DrugCard;
